export const faqs = [
  {
    question: "爆料91主要是看什么的？",
    answer:
      "爆料91把吃瓜现场之外的网友讨论整理成话题，每个话题都会交代事情的来龙去脉，再集中呈现评论区的热门讨论与舆论反应，方便你快速了解大家在聊什么。",
  },
  {
    question: "评论区的观点是真实网友留下的吗？",
    answer:
      "话题页展示的观点来自公开讨论区域的整理与汇总，我们尽量保留不同立场，并在话题开头标注整理时间，便于你判断信息的新旧程度。",
  },
  {
    question: "我可以投稿爆料线索吗？",
    answer:
      "可以。进入投稿爆料页面填写线索概述与相关背景，我们会先核实公开信息，再决定是否整理成话题。请只提交公开范围内、可被验证的内容。",
  },
  {
    question: "为什么有些话题只有讨论，没有结论？",
    answer:
      "很多热议事件本身没有唯一答案。我们更愿意呈现多方观点，而不是替网友下结论，这也是爆料91与其他内容站不同的地方。",
  },
  {
    question: "话题的更新频率是怎样的？",
    answer:
      "热门讨论会在当天内滚动补充，较大规模的舆论反应通常会在事件出现新进展后的数小时内更新，你可以关注对应板块查看最新整理。",
  },
  {
    question: "在这里讨论需要注意什么？",
    answer:
      "请围绕公开信息理性表达，避免人身攻击与隐私泄露。涉及未经证实的指控时不建议下定论，我们也会在整理时保留必要的边界。",
  },
];

export const aboutFaqs = [
  {
    question: "爆料91和其他娱乐资讯站有什么不同？",
    answer:
      "大多数站点把重点放在事件本身，爆料91更关注事件之外的声音——评论区怎么接茬、舆论如何分化，这些才是我们整理的核心内容。",
  },
  {
    question: "你们会删改网友的观点吗？",
    answer:
      "我们只做归类和精简，尽量不改变原意。带有明显攻击性或隐私信息的内容会被过滤，其余观点保留原貌。",
  },
  {
    question: "网站的内容多久更新一次？",
    answer:
      "热门讨论每日滚动更新，专题话题会在出现关键进展时追加整理，整体内容按板块节奏持续维护。",
  },
  {
    question: "可以合作或提供内容线索吗？",
    answer:
      "欢迎通过投稿页面或页面底部的联系邮箱与我们联系，说明线索方向即可，我们会在核实后回复处理情况。",
  },
];